import { render, staticRenderFns } from "./ObedienceShowResultsEntry.vue?vue&type=template&id=bbfd1b60"
import script from "./ObedienceShowResultsEntry.vue?vue&type=script&lang=ts"
export * from "./ObedienceShowResultsEntry.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports